import Vue, { ComponentOptions } from 'vue'

import ChatxModule from '@/components/chatx/chatx/chatx.module'
// eslint-disable-next-line import/extensions
import ChatAgendamentoPendencia from './chat-agendamento-pendencia.vue'

export default {
  components: {
    ...ChatxModule.exportComponents,
  },
  exportComponents: {
    ChatAgendamentoPendencia,
  },
} as ComponentOptions<Vue> & Export

type Export = { exportComponents?: any }
